<template>
    <div class="w-100">
        <v-row
            v-if="files.length || uploadedFiles.length"
            class="white pb-3"
            style="flex-wrap: nowrap"
            align="end"
            no-gutters
        >
            <div class="text-right">
                <fileChip
                    v-for="(file, index) in files"
                    :key="'f' + index"
                    :file-name="file.file_name"
                    close
                    class="mr-2"
                    @click:close="removeFile(index)"
                />
                <fileChip
                    v-for="(file, index) in uploadedFiles"
                    :key="'uf' + index"
                    :file-name="file.name"
                    close
                    class="mr-2"
                    @click:close="removeUploadedFile(index)"
                />
            </div>
        </v-row>
        <v-row
            class="white"
            style="flex-wrap: nowrap;"
            align="end"
            no-gutters
        >
            <v-btn
                color="primary"
                class="px-5"
                :loading="loader.isLoading"
                @click="saveNoteClick"
            >
                {{ editNote ? $t("Save") : $t("Add") }}
            </v-btn>
            <v-spacer/>
            <icon-button @click="addLink()">
                mdi-link
            </icon-button>
            <RichTextEditorToolbar id="client-note-editor-toolbar"/>
            <icon-button @click="addFiles()">
                mdi-paperclip
            </icon-button>
            <icon-button
                :color="isPinned ? 'orange' : 'grey'"
                @click="toggleIsPinned()"
            >
                mdi-pin
            </icon-button>
        </v-row>
    </div>
</template>

<script>
import fileChip from "../../components/fileChip";
import RichTextEditorToolbar from "../../components/RichTextEditor/RichTextEditorToolbar";

export default {
    name: "NoteEditView",
    components: {
        fileChip,
        RichTextEditorToolbar
    },
    props: {
        files: {
            type: Array,
            required: true
        },
        uploadedFiles: {
            type: Array,
            required: true
        },
        removeFile: {
            type: Function,
            required: true
        },
        removeUploadedFile: {
            type: Function,
            required: true
        },
        addLink: {
            type: Function,
            required: true
        },
        addFiles: {
            type: Function,
            required: true
        },
        saveNoteClick: {
            type: Function,
            required: true
        },
        loader: {
            type: Object,
            required: true
        },
        editNote: {
            type: Object,
            required: true
        },
        toggleIsPinned: {
            type: Function,
            required: true
        },
        isPinned: {
            type: Boolean,
            required: false
        }
    },
    setup(props, context) {
    }
};
</script>
